export const common = {
  "common.beta": "Beta",
  "common.preparing-results": "Analizando tus decisiones...",
};
